module.exports = __webpack_public_path__ + "static/media/9th Floor.ab6acda0.webp";